import React from 'react'
import dynamic from 'next/dynamic'
import { STATIC_PAGES } from '@consts/index'
import { PageProps } from '@components/pages/dynamic'
import { SizingWidgetData } from '@helpers/products/sizingWidgetData'
import { EmptyObject } from 'types/helpers'
import { SizeChartCollection } from '@helpers/sizeChart'

const DynamicPages = dynamic(() => import('@components/pages/dynamic'))
const StaticPages = dynamic(() => import('@components/pages/static'))

type PagesProps = {
  handle: string
  page: PageProps[]
  sizingWidgetData?: SizingWidgetData | EmptyObject
  sizeChartCollection?: SizeChartCollection | null
}

function Pages({
  handle,
  page,
  sizingWidgetData,
  sizeChartCollection
}: PagesProps) {
  const staticPage = STATIC_PAGES.find(
    staticPage => staticPage.handle === handle
  )

  if (staticPage) {
    return (
      <StaticPages
        pagesHandle={staticPage.handle.replace('/', '')}
        sizingWidgetData={sizingWidgetData}
        sizeChartCollection={sizeChartCollection}
      />
    )
  }
  return <DynamicPages page={page} handle={handle} />
}

export default Pages
